import { __extends } from "tslib";
import { removeElement } from '@tyler-components-web/core';
import { BaseAdapter } from '../../core/adapters/base-adapter';
import { ListDropdown } from '../../list-dropdown';
import { OPTION_CONSTANTS } from '../option';
import { OPTION_GROUP_CONSTANTS } from '../option-group';
import { isOptionGroupObject } from './select-utils';
import { POPUP_CONSTANTS } from '../../popup';
var BaseSelectAdapter = /** @class */ (function (_super) {
    __extends(BaseSelectAdapter, _super);
    function BaseSelectAdapter(component) {
        return _super.call(this, component) || this;
    }
    Object.defineProperty(BaseSelectAdapter.prototype, "popupElement", {
        get: function () {
            return this._listDropdown ? this._listDropdown.dropdownElement : undefined;
        },
        enumerable: true,
        configurable: true
    });
    BaseSelectAdapter.prototype.getOptions = function () {
        var _this = this;
        var optionGroupElements = Array.from(this._component.querySelectorAll(OPTION_GROUP_CONSTANTS.elementName));
        if (optionGroupElements.length) {
            return optionGroupElements.map(function (optionGroupElement) {
                var optionElements = Array.from(optionGroupElement.querySelectorAll(OPTION_CONSTANTS.elementName));
                var options = _this._createOptionsFromElements(optionElements);
                return { text: optionGroupElement.label, options: options };
            });
        }
        else {
            var optionElements = Array.from(this._component.querySelectorAll(OPTION_CONSTANTS.elementName));
            return this._createOptionsFromElements(optionElements);
        }
    };
    BaseSelectAdapter.prototype._createOptionsFromElements = function (optionElements) {
        return optionElements.map(function (o) {
            return {
                label: o.innerText,
                value: o.hasAttribute(OPTION_CONSTANTS.attributes.VALUE) ? o.getAttribute(OPTION_CONSTANTS.attributes.VALUE) : o.value,
                disabled: o.hasAttribute(OPTION_CONSTANTS.attributes.DISABLED)
            };
        });
    };
    BaseSelectAdapter.prototype.open = function (config) {
        this._listDropdown = new ListDropdown(this._targetElement, config);
        this._listDropdown.open();
    };
    BaseSelectAdapter.prototype.close = function () {
        if (this._listDropdown) {
            this._listDropdown.close();
            this._listDropdown.destroy();
            this._listDropdown = undefined;
        }
    };
    BaseSelectAdapter.prototype.setDismissListener = function (listener) {
        if (!this._listDropdown || !this._listDropdown.dropdownElement) {
            return;
        }
        var dropdownElement = this._listDropdown.dropdownElement;
        if (dropdownElement.targetElement) {
            dropdownElement.targetElement.addEventListener(POPUP_CONSTANTS.events.BLUR, listener);
        }
    };
    BaseSelectAdapter.prototype.toggleOptionMultiple = function (index, isSelected) {
        if (!this._listDropdown) {
            return;
        }
        this._listDropdown.toggleOptionMultiple(index, isSelected);
    };
    BaseSelectAdapter.prototype.getActiveOptionIndex = function () {
        return this._listDropdown ? this._listDropdown.getActiveOptionIndex() : -1;
    };
    BaseSelectAdapter.prototype.activateSelectedOption = function () {
        if (this._listDropdown) {
            this._listDropdown.activateSelectedOption();
        }
    };
    BaseSelectAdapter.prototype.activateFirstOption = function () {
        if (this._listDropdown) {
            this._listDropdown.activateFirstOption();
        }
    };
    BaseSelectAdapter.prototype.highlightActiveOption = function (index) {
        if (this._listDropdown) {
            this._listDropdown.activateOption(index);
        }
    };
    BaseSelectAdapter.prototype.patchSelectedValues = function (selectedValues) {
        if (this._listDropdown) {
            this._listDropdown.setSelectedValues(selectedValues);
        }
    };
    BaseSelectAdapter.prototype.setOptionsListener = function (listener) {
        var _this = this;
        var observer = new MutationObserver(function () { return listener(_this.getOptions()); });
        observer.observe(this._component, { childList: true, subtree: true });
        return function () { return observer.disconnect(); };
    };
    BaseSelectAdapter.prototype.setOptions = function (options, clear) {
        if (clear === void 0) { clear = true; }
        if (clear) {
            this._clearOptions();
        }
        for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
            var opt = options_1[_i];
            if (isOptionGroupObject(opt)) {
                var optionGroupElement = this._createOptionGroupElement(opt);
                for (var _a = 0, _b = opt.options; _a < _b.length; _a++) {
                    var option = _b[_a];
                    var optionElement = this._createOptionElement(option);
                    optionGroupElement.appendChild(optionElement);
                }
                this._component.appendChild(optionGroupElement);
            }
            else {
                var optionElement = this._createOptionElement(opt);
                this._component.appendChild(optionElement);
            }
        }
    };
    BaseSelectAdapter.prototype.appendDropdownOptions = function (options) {
        if (this._listDropdown) {
            this._listDropdown.appendOptions(options);
        }
    };
    BaseSelectAdapter.prototype.setDropdownOptions = function (options) {
        if (this._listDropdown) {
            this._listDropdown.setOptions(options);
        }
    };
    BaseSelectAdapter.prototype.scrollSelectedOptionIntoView = function () {
        if (this._listDropdown) {
            this._listDropdown.scrollSelectedOptionIntoView();
        }
    };
    BaseSelectAdapter.prototype._clearOptions = function () {
        // First we remove all option group elements
        var existingOptionGroupElements = Array.from(this._component.querySelectorAll(OPTION_GROUP_CONSTANTS.elementName));
        existingOptionGroupElements.forEach(function (optGroup) { return removeElement(optGroup); });
        // Then find all top-level option elements that aren't inside of a group, and ensure that those are removed as well
        var existingOptionElements = Array.from(this._component.querySelectorAll(OPTION_CONSTANTS.elementName));
        existingOptionElements.forEach(function (o) { return removeElement(o); });
    };
    BaseSelectAdapter.prototype._createOptionGroupElement = function (group) {
        var optionGroupElement = document.createElement(OPTION_GROUP_CONSTANTS.elementName);
        optionGroupElement.label = group.text || '';
        return optionGroupElement;
    };
    BaseSelectAdapter.prototype._createOptionElement = function (option) {
        var optionElement = document.createElement(OPTION_CONSTANTS.elementName);
        optionElement.value = option.value;
        optionElement.textContent = option.label;
        if (option.disabled) {
            optionElement.disabled = option.disabled;
        }
        return optionElement;
    };
    return BaseSelectAdapter;
}(BaseAdapter));
export { BaseSelectAdapter };
